export const AppRoutes = {
  root: '',
  notFound: 'not-found',
  auth: 'auth',
  login: 'login',

  // New RESTful admin routes
  admin: 'admin',
  countries: 'countries',
  partners: 'partners',
  beneficiaries: 'beneficiaries',
  users: 'users',
  forms: 'forms',
  dashboard: 'dashboard',

  // Legacy routes (to be removed)
  main: 'main',
  beneficiariesCreate: 'create',
  beneficiariesEdit: 'edit',
  formsCreate: 'create',
  formsEdit: 'edit',
  partnersCreate: 'create',
  partnersEdit: 'edit',
  countriesCreate: 'create',
  countriesEdit: 'edit',
} as const;
